// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"2fbd700b","513":"0833e5d2","703":"ac8c8501","787":"d0770b2d"}[chunkId] + ".chunk.js";
};